import { createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER,
  DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_STATUS_FILTERS,
  DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_TYPE_FILTERS,
  DEFAULT_TOR_EMPLOYEE_SORT_MODEL
} from "../../util/filterTimeOffRequests";

const initialState = {
  startDateFilter: null,
  endDateFilter: null,
  dateTypeFilter: DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER,
  timeOffTypeFilters: DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_TYPE_FILTERS,
  timeOffStatusFilters: DEFAULT_EMPLOYEE_TIME_OFF_REQUEST_STATUS_FILTERS,
  searchString: "",
  timeOffRequestFoundByReferenceNumberSearch: null,
  timeOffRequestFoundByReferenceNumberSearchIsLoading: false,
  timeOffRequestFoundByReferenceNumberSearchIsDialogOpen: false,
  searchStringErrors: "",
  startDateFilterErrors: "",
  endDateFilterErrors: "",
  mobileSortByValue: DEFAULT_EMPLOYEE_TIME_OFF_DATE_TYPE_FILTER,
  sortModel: DEFAULT_TOR_EMPLOYEE_SORT_MODEL,
};

export const timeOffRequestSlice = createSlice({
  name: "timeOffRequest",
  initialState,
  reducers: {
    updateDateTypeFilter: (state, action) => {
      state.dateTypeFilter = action.payload;
    },
    updateStartDateFilter: (state, action) => {
      state.startDateFilter = action.payload;
    },
    updateEndDateFilter: (state, action) => {
      state.endDateFilter = action.payload;
    },
    updateTimeOffTypeFilters: (state, action) => {
      state.timeOffTypeFilters = action.payload;
    },
    updateTimeOffStatusFilters: (state, action) => {
      state.timeOffStatusFilters = action.payload;
    },
    updateSearchString: (state, action) => {
      state.searchString = action.payload;
    },
    updateTimeOffRequestFoundByReferenceNumberSearch: (state, action) => {
      state.timeOffRequestFoundByReferenceNumberSearch = action.payload;
    },
    updateTimeOffRequestFoundByReferenceNumberSearchIsLoading: (state, action) => {
      state.timeOffRequestFoundByReferenceNumberSearchIsLoading = action.payload;
    },
    updateTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen: (state, action) => {
      state.timeOffRequestFoundByReferenceNumberSearchIsDialogOpen = action.payload;
    },
    updateSearchStringErrors: (state, action) => {
      state.searchStringErrors = action.payload;
    },
    updateStartDateFilterErrors: (state, action) => {
      state.startDateFilterErrors = action.payload;
    },
    updateEndDateFilterErrors: (state, action) => {
      state.endDateFilterErrors = action.payload;
    },
    updateMobileSortByValue: (state, action) => {
      state.mobileSortByValue = action.payload;
    },
    updateSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    clearAllTimeOffRequestState: () => initialState,
  },
});

export const {
  updateDateTypeFilter,
  updateStartDateFilter,
  updateEndDateFilter,
  updateTimeOffTypeFilters,
  updateTimeOffStatusFilters,
  updateSearchString,
  updateTimeOffRequestFoundByReferenceNumberSearch,
  updateTimeOffRequestFoundByReferenceNumberSearchIsLoading,
  updateTimeOffRequestFoundByReferenceNumberSearchIsDialogOpen,
  updateSearchStringErrors,
  updateStartDateFilterErrors,
  updateEndDateFilterErrors,
  updateSortModel,
  clearAllTimeOffRequestState,
  updateMobileSortByValue,
} = timeOffRequestSlice.actions;

export const selectTimeOffRequest = (state) => state.timeOffRequest;

export default timeOffRequestSlice.reducer;
